import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1073.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M5368 9200 c-244 -42 -284 -385 -58 -493 59 -28 178 -30 230 -3 48
25 108 84 128 126 26 55 23 183 -6 238 -55 105 -166 154 -294 132z m175 -102
c47 -37 72 -101 64 -172 -11 -109 -62 -158 -169 -164 -79 -5 -128 17 -168 75
-21 31 -25 48 -25 108 0 60 4 78 26 111 38 58 79 75 165 72 59 -3 77 -8 107
-30z"
          />
          <path
            d="M4923 9179 c-32 -8 -44 -16 -48 -32 -3 -12 -19 -83 -36 -157 -17 -74
-33 -138 -35 -142 -14 -22 -38 3 -122 130 l-91 139 -61 -10 c-45 -7 -60 -14
-60 -26 0 -21 14 -105 44 -281 37 -208 31 -193 69 -185 18 4 33 8 35 10 3 3
-25 180 -38 240 -24 111 -31 157 -27 162 3 2 46 -57 97 -131 l91 -137 37 6
c80 13 80 13 96 62 8 27 20 75 26 107 28 138 60 203 60 120 0 -29 25 -183 56
-342 4 -19 9 -21 32 -16 15 4 31 10 36 14 7 7 -20 189 -55 370 -23 115 -25
117 -106 99z"
          />
          <path
            d="M5826 9139 c-7 -31 -41 -217 -62 -341 -9 -53 -14 -103 -11 -112 4 -9
18 -16 35 -16 26 0 29 4 40 58 7 32 12 68 12 80 0 18 6 22 34 22 85 0 89 -4
132 -108 38 -93 41 -97 77 -105 21 -5 40 -7 43 -4 3 3 -12 45 -34 94 -41 89
-41 113 -3 113 28 0 79 38 96 71 39 75 11 165 -65 208 -35 19 -136 44 -237 57
-49 6 -52 5 -57 -17z m176 -80 c88 -14 118 -37 118 -90 0 -27 -7 -46 -21 -60
-20 -20 -29 -21 -103 -16 -131 10 -130 10 -123 77 9 79 23 113 45 106 9 -3 47
-10 84 -17z"
          />
          <path
            d="M6351 9029 c-32 -86 -141 -418 -141 -431 0 -16 20 -24 203 -88 109
-37 125 -37 137 -4 6 14 10 27 10 28 0 2 -55 22 -122 46 -68 23 -127 46 -131
50 -7 6 25 115 37 128 3 2 44 -10 91 -27 108 -39 120 -39 134 -1 12 35 17 32
-109 70 -41 13 -79 26 -83 30 -4 4 0 32 10 63 22 69 24 69 153 22 106 -39 135
-43 144 -19 17 43 10 48 -146 99 -84 27 -159 51 -165 53 -7 2 -17 -7 -22 -19z"
          />
          <path
            d="M4117 8983 l-78 -27 6 -91 c18 -245 33 -406 37 -411 3 -2 17 0 32 5
25 10 26 14 26 79 l0 68 98 32 c54 18 105 32 114 32 9 0 26 -16 38 -35 34 -56
46 -64 77 -56 16 4 28 14 28 22 0 9 -58 104 -130 212 -97 146 -135 196 -150
196 -11 0 -55 -12 -98 -26z m112 -100 c17 -27 42 -65 57 -86 14 -22 23 -45 20
-52 -7 -18 -158 -67 -169 -56 -6 6 -10 58 -11 117 -1 107 -1 108 24 115 43 12
48 10 79 -38z"
          />
          <path
            d="M3700 8803 c-91 -47 -167 -87 -169 -89 -2 -1 -1 -15 3 -29 8 -32 25
-32 97 5 51 25 60 27 73 15 8 -8 51 -88 96 -177 45 -90 86 -167 91 -172 10
-11 59 12 59 27 0 5 -41 90 -91 189 -50 99 -87 184 -82 188 4 4 36 22 70 40
l63 32 -15 29 c-9 16 -19 29 -23 28 -4 0 -81 -39 -172 -86z"
          />
          <path
            d="M6808 8829 c-65 -34 -87 -112 -49 -175 10 -16 48 -59 84 -94 69 -66
85 -97 67 -131 -23 -43 -90 -42 -155 2 -38 27 -55 57 -55 98 0 22 -7 31 -31
41 -40 17 -52 1 -43 -59 11 -86 80 -154 182 -181 106 -28 206 49 187 146 -5
27 -28 59 -91 125 -87 92 -98 116 -70 154 18 25 78 25 124 1 33 -17 62 -61 62
-94 0 -17 36 -42 60 -42 17 0 11 94 -7 120 -44 64 -128 111 -197 110 -17 -1
-48 -10 -68 -21z"
          />
          <path
            d="M7224 8608 c-16 -24 -31 -45 -35 -48 -9 -8 -126 -183 -138 -207 -34
-67 3 -175 77 -226 73 -51 132 -58 200 -26 38 19 58 40 130 134 4 6 24 35 44
65 21 30 46 66 57 80 12 14 21 31 21 39 0 15 -28 40 -46 41 -13 0 -99 -111
-156 -201 -61 -96 -125 -122 -195 -79 -49 29 -66 63 -61 114 4 36 23 69 93
168 49 68 92 128 97 135 11 13 -23 53 -46 53 -7 0 -26 -19 -42 -42z"
          />
          <path
            d="M3292 8560 c-40 -28 -72 -57 -72 -66 0 -8 9 -36 19 -62 11 -26 45
-114 76 -197 73 -197 73 -195 87 -195 7 0 21 7 32 15 18 14 18 16 -4 75 -13
35 -19 65 -14 69 24 22 161 118 174 123 8 3 37 -12 63 -33 47 -37 48 -37 77
-21 17 9 30 20 30 23 0 3 -43 41 -97 85 -53 43 -101 84 -107 89 -46 42 -176
145 -183 145 -6 0 -42 -23 -81 -50z m161 -102 c42 -35 76 -69 74 -77 -3 -22
-137 -115 -148 -104 -6 6 -26 52 -45 104 l-36 94 27 22 c14 13 32 23 39 23 7
0 47 -28 89 -62z"
          />
          <path
            d="M7617 8243 c-47 -49 -123 -128 -170 -178 l-86 -90 82 -83 c110 -111
157 -142 218 -142 40 0 55 6 83 30 37 33 61 88 52 117 -11 33 -6 38 35 40 48
2 83 30 100 81 20 59 -2 100 -105 199 -50 49 -98 94 -107 101 -14 10 -28 0
-102 -75z m161 -84 c75 -70 87 -91 71 -121 -16 -30 -28 -38 -64 -38 -23 0 -43
14 -92 62 -35 34 -63 67 -63 72 0 13 72 87 81 84 4 -2 34 -28 67 -59z m-120
-162 c53 -55 62 -70 62 -100 0 -42 -28 -67 -73 -67 -21 0 -46 16 -95 63 -37
34 -70 66 -74 72 -11 15 84 113 102 104 8 -5 43 -37 78 -72z"
          />
          <path
            d="M2932 8261 c-24 -11 -49 -26 -57 -33 -66 -62 -135 -133 -135 -139 0
-4 51 -60 113 -125 63 -66 135 -143 162 -171 26 -29 51 -53 55 -53 17 0 160
150 179 188 60 118 27 238 -89 321 -48 35 -166 41 -228 12z m180 -74 c50 -30
86 -81 94 -133 8 -56 -21 -117 -83 -175 l-46 -42 -99 99 c-54 54 -108 112
-120 127 l-20 29 38 40 c77 79 163 100 236 55z"
          />
          <path
            d="M8248 7423 c-32 -20 -48 -52 -48 -96 0 -81 103 -127 167 -73 97 82
-11 236 -119 169z"
          />
          <path
            d="M2415 7413 c-11 -3 -32 -17 -47 -31 -22 -20 -28 -35 -28 -70 0 -96
106 -138 174 -69 28 28 32 37 28 74 -4 43 -41 93 -68 93 -7 0 -18 2 -26 4 -7
2 -22 1 -33 -1z"
          />
          <path
            d="M3507 7414 c-9 -9 -9 -1470 0 -1715 3 -101 8 -178 11 -171 3 11 7 10
21 -2 11 -10 47 -15 129 -18 61 -1 112 0 112 4 0 4 14 6 30 6 19 -1 30 -6 30
-16 0 -12 9 -13 47 -8 26 3 49 10 52 14 9 12 221 15 221 3 0 -6 23 -8 58 -5
59 6 119 7 209 4 102 -3 93 -35 93 343 0 362 6 408 57 514 36 73 133 171 203
205 89 44 180 58 380 58 149 0 181 -3 194 -16 9 -8 16 -18 16 -20 0 -17 -25
-46 -51 -59 -99 -52 -177 -149 -209 -261 -18 -62 -20 -98 -19 -349 1 -154 4
-309 8 -345 6 -64 6 -65 35 -62 33 4 153 -16 179 -30 12 -6 23 -5 32 2 9 8 14
7 19 -5 3 -8 17 -20 31 -25 16 -6 23 -14 19 -25 -3 -8 -1 -15 4 -15 6 0 14 9
17 20 5 17 15 20 66 20 33 0 59 -4 59 -10 0 -5 9 -10 20 -10 12 0 20 7 20 18
0 14 2 14 9 3 5 -8 7 -20 4 -27 -2 -6 0 -15 6 -19 7 -4 11 5 11 24 0 16 3 38
7 48 6 16 8 15 14 -7 4 -15 7 4 8 53 l1 77 -90 0 c-79 0 -95 3 -130 25 -81 51
-91 127 -33 239 65 124 284 478 323 524 7 7 17 23 23 35 28 50 91 143 110 160
34 29 89 39 133 23 45 -15 71 -49 241 -316 306 -482 326 -529 274 -614 -38
-60 -75 -76 -180 -76 l-91 0 1 -97 c0 -54 3 -92 6 -85 6 16 389 18 395 1 3 -8
65 -11 198 -11 133 0 195 3 198 11 5 14 82 15 82 1 0 -5 18 -10 39 -10 22 0
41 -5 44 -12 7 -21 18 -2 21 34 5 58 8 64 15 28 14 -71 23 174 18 515 -4 363
-10 417 -67 585 -26 75 -121 266 -147 296 -10 10 -30 36 -44 57 -28 40 -115
134 -170 182 -125 111 -303 212 -449 255 -190 57 -86 53 -1531 57 -734 2
-1338 0 -1342 -3z"
          />
          <path
            d="M1940 6723 c-40 -16 -66 -64 -100 -189 -17 -60 -33 -117 -36 -126 -7
-24 -1 -27 260 -98 43 -11 106 -30 138 -42 33 -11 62 -18 65 -15 3 3 21 59 40
124 55 190 48 254 -34 294 -52 25 -104 21 -138 -11 -28 -26 -30 -26 -45 10 -7
17 -22 37 -34 45 -20 15 -87 19 -116 8z m104 -89 c9 -8 16 -30 15 -47 -1 -43
-43 -182 -55 -181 -37 4 -107 29 -111 40 -6 16 33 150 53 182 17 27 74 31 98
6z m208 -41 c20 -18 24 -81 8 -129 -5 -16 -14 -48 -20 -71 -8 -33 -16 -43 -31
-43 -29 0 -129 30 -129 39 0 21 50 175 64 196 20 30 79 35 108 8z"
          />
          <path
            d="M8725 6615 c-27 -7 -123 -30 -212 -51 -145 -34 -163 -40 -163 -59 0
-48 52 -210 80 -248 55 -74 138 -114 221 -104 89 11 147 50 196 135 38 64 34
157 -13 330 -4 15 -44 14 -109 -3z m63 -130 c19 -75 11 -139 -25 -183 -39 -49
-77 -66 -140 -65 -98 1 -161 66 -178 184 l-7 47 34 7 c27 6 164 37 253 58 40
10 50 2 63 -48z"
          />
          <path
            d="M1760 6198 l0 -36 98 -11 c222 -27 245 -32 280 -67 27 -27 32 -39 32
-78 0 -61 -21 -99 -66 -121 -34 -16 -44 -16 -203 3 -91 11 -169 17 -173 14 -4
-4 -9 -19 -13 -33 -8 -33 -10 -32 198 -55 172 -19 213 -14 264 29 63 55 83
186 39 261 -35 61 -84 84 -218 102 -62 8 -141 18 -175 21 l-63 6 0 -35z"
          />
          <path
            d="M8444 6087 c-2 -7 0 -25 5 -39 9 -23 18 -27 73 -35 l63 -8 12 -100
c14 -110 11 -145 -13 -145 -8 0 -33 -9 -55 -20 -34 -18 -39 -25 -37 -51 1 -17
8 -33 14 -36 6 -2 76 23 155 55 138 57 252 102 293 116 17 6 18 14 12 99 -4
50 -12 97 -19 104 -7 6 -106 23 -222 37 -115 15 -225 29 -243 32 -22 3 -34 1
-38 -9z m434 -122 c9 -3 12 -18 10 -42 -3 -36 -4 -38 -92 -75 -101 -43 -116
-45 -116 -20 -1 9 -5 48 -10 87 -5 38 -7 72 -5 76 4 6 187 -16 213 -26z"
          />
          <path
            d="M1983 5682 c-15 -16 -36 -55 -47 -88 -10 -32 -25 -79 -32 -103 -26
-82 -72 -104 -119 -56 -21 20 -25 34 -25 81 0 52 3 59 35 90 35 32 47 76 25
89 -6 4 -25 -2 -43 -12 -123 -72 -108 -300 23 -341 40 -12 50 -12 82 1 48 20
66 50 99 165 31 107 55 137 98 127 84 -20 94 -161 16 -221 -25 -19 -35 -34
-35 -54 0 -35 7 -41 39 -29 69 27 111 99 111 194 0 116 -56 185 -151 185 -39
0 -53 -5 -76 -28z"
          />
          <path
            d="M8908 5583 l-3 -78 -210 0 -210 0 0 -35 0 -35 180 -6 c99 -4 192 -7
208 -8 l27 -1 0 -80 0 -80 40 0 39 0 3 173 c4 231 5 227 -37 227 l-34 0 -3
-77z"
          />
          <path
            d="M3505 5438 c-3 -29 -5 -433 -3 -898 l3 -845 1313 -3 c1287 -2 1316
-2 1413 18 94 19 168 40 214 60 322 138 536 332 679 616 103 205 138 380 134
673 l-3 194 -50 3 c-27 1 -117 5 -200 8 -363 14 -654 27 -707 31 -53 3 -58 2
-63 -18 -2 -12 -6 -116 -8 -232 l-3 -210 -34 -70 c-62 -128 -194 -236 -324
-265 -49 -11 -432 -15 -458 -5 -10 4 -18 17 -18 30 0 16 16 32 63 61 72 44 91
62 133 124 33 47 55 93 73 149 11 35 16 427 5 454 -4 11 -29 15 -111 16 -59 1
-110 4 -114 7 -23 14 -52 -20 -103 -117 -30 -58 -87 -157 -126 -220 -40 -63
-80 -126 -89 -141 -74 -124 -210 -324 -234 -344 -21 -18 -40 -24 -75 -24 -60
0 -100 24 -140 86 -18 27 -37 56 -42 64 -23 35 -146 227 -155 243 -15 25 -104
167 -131 207 -12 19 -45 80 -73 134 -39 77 -51 110 -51 145 l0 46 -43 2 c-373
15 -657 39 -657 55 0 6 7 8 15 4 8 -3 25 -1 37 4 19 7 16 9 -19 9 l-42 1 -6
-52z"
          />
          <path
            d="M2161 5283 c-21 -4 -22 -8 -17 -46 10 -72 25 -231 22 -234 -2 -2 -33
-6 -70 -10 -46 -4 -66 -3 -66 6 0 26 -32 197 -38 203 -4 4 -18 5 -31 1 -23 -6
-24 -7 -17 -92 4 -47 8 -97 9 -111 2 -23 -2 -25 -62 -33 -35 -4 -65 -6 -67 -4
-2 2 -11 63 -21 135 l-17 132 -28 0 c-16 0 -31 -6 -34 -14 -3 -8 1 -63 10
-123 8 -59 18 -132 22 -162 l6 -53 52 6 c257 29 425 52 431 58 7 6 -32 324
-40 338 -3 6 -9 9 -13 9 -4 -1 -18 -4 -31 -6z"
          />
          <path
            d="M8480 5256 c0 -32 4 -36 55 -60 64 -29 63 -26 38 -163 l-17 -92 -41
-6 c-22 -2 -51 -6 -64 -7 -19 -2 -27 -11 -33 -37 -5 -18 -7 -36 -3 -39 6 -6
436 26 480 36 28 7 30 11 43 95 8 47 12 92 9 99 -2 8 -40 29 -83 48 -44 18
-117 51 -163 73 -144 66 -193 87 -207 87 -9 0 -14 -12 -14 -34z m313 -178 l79
-39 -5 -36 c-4 -19 -8 -38 -11 -40 -3 -3 -52 -8 -110 -10 l-106 -6 0 34 c0 31
14 105 25 136 5 16 34 7 128 -39z"
          />
          <path
            d="M2214 4804 c-90 -105 -79 -100 -124 -60 -22 20 -55 38 -75 42 -81 15
-166 -44 -180 -124 -6 -38 14 -140 52 -255 18 -59 -5 -61 276 19 207 58 207
58 207 86 0 38 -16 42 -88 24 -89 -24 -97 -22 -110 23 -19 61 -15 72 53 151
57 66 64 79 59 105 -3 17 -10 34 -14 38 -4 5 -29 -17 -56 -49z m-170 -117 c24
-24 57 -119 60 -171 1 -27 -3 -29 -66 -48 -37 -12 -73 -18 -81 -15 -7 3 -24
44 -37 91 -19 73 -21 90 -10 116 15 37 35 49 78 50 21 0 41 -8 56 -23z"
          />
          <path
            d="M8395 4769 c-5 -22 -3 -34 6 -40 8 -5 92 -35 187 -66 94 -31 172 -60
172 -63 0 -4 -67 -13 -149 -20 -81 -6 -153 -15 -158 -19 -6 -3 -18 -30 -28
-60 l-18 -55 45 -40 c24 -23 77 -71 118 -108 40 -37 72 -70 69 -72 -3 -3 -65
17 -140 44 -176 63 -234 80 -247 71 -6 -3 -12 -19 -14 -35 l-3 -28 227 -77
c125 -43 231 -75 236 -72 6 3 17 30 25 59 l16 53 -77 73 c-42 40 -98 92 -125
116 -66 60 -57 66 110 75 186 10 184 10 208 78 10 31 16 59 13 63 -9 9 -436
154 -453 154 -7 0 -16 -14 -20 -31z"
          />
          <path
            d="M2175 4314 c-67 -34 -99 -67 -125 -127 -61 -142 12 -308 160 -361
160 -58 344 73 344 244 0 65 -37 151 -86 199 -77 75 -198 93 -293 45z m224
-82 c109 -88 108 -234 -3 -309 -35 -24 -51 -28 -112 -28 -62 0 -75 3 -108 29
-74 56 -100 178 -53 247 24 35 89 85 122 93 48 11 119 -4 154 -32z"
          />
          <path
            d="M8185 4116 c-93 -43 -166 -154 -165 -251 2 -158 160 -286 313 -253
68 14 94 28 138 75 51 53 71 97 77 169 6 84 -16 148 -71 201 -83 82 -195 105
-292 59z m173 -71 c49 -21 81 -52 103 -100 25 -54 24 -90 -5 -152 -26 -55 -77
-98 -132 -109 -64 -13 -159 32 -201 95 -18 26 -23 48 -23 95 0 53 5 67 34 107
18 25 49 53 67 62 43 21 109 22 157 2z"
          />
          <path
            d="M2592 3853 c-29 -21 -113 -81 -187 -133 -74 -52 -134 -101 -135 -107
0 -25 55 -92 76 -93 11 0 82 14 157 30 76 17 144 30 152 30 28 0 15 -32 -65
-164 -44 -73 -80 -138 -80 -145 0 -12 47 -80 64 -93 9 -6 40 10 76 39 8 7 69
50 135 97 183 129 184 130 185 147 0 9 -8 23 -18 32 -17 16 -25 12 -126 -61
-60 -42 -118 -82 -129 -89 -12 -6 -33 -23 -48 -37 -15 -14 -32 -26 -38 -26
-13 0 -5 20 39 93 19 32 40 66 45 75 6 9 23 38 38 64 l28 47 -24 38 c-43 68
-40 68 -196 34 -152 -34 -171 -36 -171 -21 0 6 5 10 11 10 10 0 78 46 240 163
77 56 80 59 66 80 -22 33 -39 31 -95 -10z"
          />
          <path
            d="M7873 3690 c-16 -25 -9 -42 25 -63 41 -25 82 -65 82 -78 0 -7 -12
-28 -26 -46 l-26 -35 -109 3 c-107 4 -109 3 -136 -24 -38 -37 -21 -47 84 -47
52 0 84 -4 89 -12 4 -6 6 -37 5 -67 -2 -71 21 -110 81 -140 103 -49 162 -13
321 200 l27 36 -113 88 c-61 49 -145 115 -185 147 -78 62 -100 69 -119 38z
m242 -233 c67 -51 68 -54 35 -101 -65 -90 -97 -116 -143 -116 -27 0 -77 50
-77 76 0 30 69 139 108 171 17 14 20 12 77 -30z"
          />
          <path
            d="M2993 3383 c-11 -21 -64 -117 -117 -214 -53 -97 -96 -181 -96 -187 0
-14 117 -126 137 -130 8 -2 31 7 51 21 20 13 98 62 172 108 74 46 149 93 167
104 37 23 40 35 15 58 -25 22 -28 22 -83 -14 -27 -17 -53 -29 -58 -27 -16 5
-161 148 -161 158 0 6 12 32 26 59 26 48 27 49 8 75 -26 35 -37 33 -61 -11z
m56 -259 c34 -31 61 -60 61 -64 0 -11 -166 -120 -183 -120 -8 0 -24 11 -37 25
l-24 26 19 37 c45 85 87 152 95 152 5 0 36 -25 69 -56z"
          />
          <path
            d="M7470 3241 c-125 -119 -125 -119 -106 -140 11 -11 24 -21 30 -21 6 0
52 38 101 85 50 47 95 85 100 85 17 0 85 -74 85 -92 0 -8 -31 -45 -70 -81 -38
-36 -70 -71 -70 -77 0 -16 26 -40 42 -40 7 1 42 30 78 65 36 36 72 65 81 65
16 0 75 -57 81 -78 2 -6 -40 -55 -92 -107 -93 -93 -94 -94 -75 -114 10 -12 23
-21 29 -21 6 0 67 53 136 119 l124 118 -125 129 c-68 71 -144 150 -168 177
-25 26 -47 47 -50 47 -3 0 -62 -54 -131 -119z"
          />
          <path
            d="M7175 3011 c-67 -38 -101 -74 -121 -127 -16 -41 -16 -47 0 -88 9 -24
25 -51 36 -61 32 -29 97 -30 180 -2 118 40 145 42 169 18 33 -33 27 -69 -20
-113 -40 -38 -43 -39 -105 -36 -51 2 -67 -1 -81 -15 -17 -17 -17 -19 2 -33 56
-42 142 -34 216 20 59 44 83 93 76 159 -10 104 -95 134 -233 82 -71 -27 -142
-33 -162 -13 -7 7 -12 29 -12 49 0 31 7 43 41 72 48 42 78 49 141 34 42 -9 50
-8 68 8 28 25 26 30 -23 54 -60 29 -112 27 -172 -8z"
          />
          <path
            d="M3397 2947 c-31 -45 -83 -119 -115 -164 -31 -46 -63 -83 -69 -83 -7
0 -36 18 -65 40 -29 22 -58 40 -63 40 -6 0 -18 -12 -27 -27 -16 -27 -16 -27
27 -58 24 -16 96 -68 161 -114 91 -65 121 -82 133 -74 28 18 24 48 -10 74 -82
63 -84 65 -72 90 6 13 18 33 27 44 24 30 105 142 154 213 l44 62 -24 20 c-13
11 -27 19 -33 20 -5 0 -36 -37 -68 -83z"
          />
          <path
            d="M3627 2893 c-5 -8 -38 -131 -98 -358 -33 -128 -39 -115 77 -180 l66
-37 171 177 c95 97 173 181 175 185 2 5 -9 16 -23 26 -26 17 -26 17 -68 -24
-24 -23 -51 -42 -61 -42 -21 0 -196 97 -196 109 0 4 7 33 15 65 14 55 14 59
-2 72 -20 15 -49 18 -56 7z m105 -270 c35 -21 66 -42 70 -48 9 -13 -131 -155
-153 -155 -9 0 -27 8 -39 18 l-22 18 27 102 c17 62 33 102 41 102 7 0 41 -17
76 -37z"
          />
          <path
            d="M6787 2776 c-92 -33 -141 -100 -139 -191 1 -42 14 -76 78 -202 79
-156 90 -168 128 -140 17 12 13 23 -58 165 -88 176 -95 214 -48 262 38 38 104
56 144 39 40 -17 66 -54 139 -201 52 -106 67 -128 85 -128 12 0 27 7 34 15 11
13 1 39 -60 158 -85 166 -101 188 -156 216 -47 24 -92 26 -147 7z"
          />
          <path
            d="M6385 2589 c-60 -21 -118 -41 -128 -45 -37 -12 -86 -65 -93 -99 -13
-69 32 -155 81 -155 33 0 39 -14 20 -49 -41 -81 18 -166 115 -163 33 1 273 72
287 86 6 5 -155 460 -163 462 -5 1 -58 -16 -119 -37z m104 -121 c12 -34 17
-66 13 -70 -15 -15 -158 -60 -192 -60 -61 0 -93 73 -52 120 17 22 149 71 189
72 17 0 25 -11 42 -62z m48 -150 c11 -15 38 -107 32 -112 -2 -2 -37 -15 -78
-30 -119 -42 -164 -32 -164 35 0 42 22 60 111 91 93 32 87 31 99 16z"
          />
          <path
            d="M4125 2611 c-125 -31 -202 -133 -193 -256 6 -69 23 -109 70 -157 36
-37 68 -54 175 -97 56 -22 75 -26 83 -17 5 7 36 82 69 167 33 85 69 176 80
202 31 72 28 82 -26 102 -27 10 -53 22 -59 27 -12 8 -140 38 -159 37 -5 -1
-23 -4 -40 -8z m145 -90 c53 -17 55 -18 54 -52 -1 -19 -20 -79 -43 -134 -76
-179 -67 -165 -98 -156 -45 13 -106 47 -130 73 -98 106 -18 288 127 287 19 0
60 -8 90 -18z"
          />
          <path
            d="M5194 2126 c-26 -26 -34 -42 -34 -71 0 -52 53 -105 104 -105 51 0 95
42 103 98 5 39 3 45 -31 77 -51 48 -95 48 -142 1z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
